import { encodeForURL } from '../../../global/formatters/string-formatter'

export const getUrlParameter = (paramName) => {
  const searchParams = new URLSearchParams(window.location.search)

  const searchParam = searchParams.get(paramName)

  return encodeForURL(searchParam)
}

/*
returns true of all parameters inside needleParams exist inside of heystackParams
*/
export const compareParameters = (needleParams, haystackParams) => {
  const needles = new URLSearchParams(needleParams.toLowerCase())
  const size = new Set(needles.keys()).size
  if (size === 0) {
    return false
  }

  const heystack = new URLSearchParams(haystackParams.toLowerCase())
  let found = 0
  needles.forEach((value, key) => {
    if (heystack.has(key, value)) {
      found++
    }
  })
  return found === size
}

export const subtractParams = (paramsToSubtractFrom, paramsToSubtract) => {
  const subtractFrom = new URLSearchParams(paramsToSubtractFrom)
  const subtractFromTemp = new URLSearchParams(paramsToSubtractFrom)

  const subtractThese = new URLSearchParams(paramsToSubtract.toLowerCase())
  if (subtractThese.size === 0 || subtractFrom.size === 0) return subtractFrom
  for (const [q, v] of subtractFrom) {
    const lowerCaseQ = q.toLowerCase()
    const lowerCaseV = v.toLowerCase()
    if (subtractThese.get(lowerCaseQ) === lowerCaseV) {
      subtractFromTemp.delete(q)
    }
  }
  return encodeForURL(subtractFromTemp)
}

export const isExperienceManager = (page) => {
  return (
    page?.isPreview() &&
    page?.getUrl().includes('?endpoint') &&
    page?.getUrl().includes('&token')
  )
}
